// Import model
import { StartProjectGenerateContentRequest } from '../models/StartProjectGenerateContentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectGenerateContentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectGenerateContentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectGenerateContentRequest instance
   */
  static deserialize(json: string): StartProjectGenerateContentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectGenerateContentRequest instance
   */
  static fromObject(obj: any): StartProjectGenerateContentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectGenerateContentRequest');
    }


    const instance: StartProjectGenerateContentRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectGenerateContentRequest instances
   */
  static deserializeArray(json: string): StartProjectGenerateContentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectGenerateContentRequest instance to a JSON string
   */
  static serialize(instance: StartProjectGenerateContentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectGenerateContentRequest instance to a plain object
   */
  static toObject(instance: StartProjectGenerateContentRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartProjectGenerateContentRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectGenerateContentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
